import {Menu} from "antd";
import React from "react";
import "./contextMenu.css"

const {SubMenu} = Menu;


export interface MenuItemConfig {
    title: string;
    context: any,
    enabled: boolean,
    childs: Array<MenuItemConfig>,
}

interface PreparedMenuItem {
    key: string;
    title: string;
    childs: Array<PreparedMenuItem>;
}

type PopupOpts = {
    menu: Array<MenuItemConfig>,
    visible: boolean,
    x: number;
    y: number;

    onClick?: (context: any) => void;
    onMouseEnter?: (context: any) => void;
    onMouseLeave?: (context: any) => void;
}

interface MenuItems {
    items: PreparedMenuItem[],
    key2item: Map<string, MenuItemConfig>,
}

/// see eventKey of menu: https://github.com/ant-design/ant-design/issues/33699l
export function ContextMenu({menu, visible, x, y, onClick, onMouseEnter, onMouseLeave}: PopupOpts) {
    const [menuItems, setMenuItems] = React.useState<MenuItems>({items: [], key2item: new Map<string, MenuItemConfig>()});
    React.useEffect(() => {
        const menuItems = preprocessMenuItems(menu);
        setMenuItems(menuItems);
    }, [menu]);

    if (!visible) {
        return <></>
    }

    function MenuItem({elem}: { elem: PreparedMenuItem }) {
        if (elem.childs.length > 0) {
            return (
                <SubMenu key={elem.key} title={elem.title} {...{eventKey: elem.key}}>
                    {elem.childs.map((x) => {
                        return (
                            <MenuItem {...{key: x.key}} key={x.key} elem={x}/>
                        )
                    })}
                </SubMenu>
            )
        }

        return <Menu.Item onMouseEnter={() => onMouseEnter && onMouseEnter(menuItems.key2item.get(elem.key)!.context!)}
                          onMouseLeave={() => onMouseLeave && onMouseLeave(menuItems.key2item.get(elem.key)!.context!)}
                          key={elem.key} {...{eventKey: elem.key}}>
            {elem.title}
        </Menu.Item>
    }

    return <div className={"popup"} style={{left: `${x}px`, top: `${y}px`}}>
        <Menu onClick={(elem) => onClick && onClick(menuItems.key2item.get(elem.key)!.context!)}>
            {
                menuItems.items.map((elem) =>
                    <MenuItem key={elem.key} elem={elem}/>
                )
            }
        </Menu>
    </div>
}


function preprocessMenuItems(menu: Array<MenuItemConfig>): MenuItems {
    const itemMap = new Map<string, MenuItemConfig>();

    let idx = 0;

    function convert(it: MenuItemConfig): PreparedMenuItem {
        let childs = new Array<PreparedMenuItem>();
        for (const child of it.childs) {
            if (!child.enabled) {
                continue
            }
            childs.push(convert(child))
        }


        idx += 1;
        itemMap.set(idx.toString(), it);
        return {
            key: idx.toString(),
            title: it.title,
            childs,
        }
    }

    let new_items = []
    for (const item of menu) {
        if (!item.enabled) {
            continue
        }
        new_items.push(convert(item))
    }

    return {
        items: new_items,
        key2item: itemMap,
    }
}
